import { outgoMappingKeys } from './mappings';

export default rawData =>
    Object.fromEntries(
        Object.keys(outgoMappingKeys).map(key => [[outgoMappingKeys[key]], rawData[key]])
    );
